export default __webpack_public_path__ + "static/media/img_1.a2636608.png";